// src/components/Contact.js
import React from 'react';
import './styles/contact.css'

function Contact() {
  return (
    <section id="contact">
      <h2>Contact Me</h2>
      <p>Email: <a href="mailto:summercai8@gmail.com">summercai8@gmail.com</a></p>
    </section>
  );
}

export default Contact;
